export default {
  changedKeyColor: "#fffff3",
};
